import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="section-padding bg-background-50">
      <div className="section-container">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10 md:mb-14">
          专题合集
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.slice(0, 4).map((item, i) => (
            <div
              key={i}
              className="group flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors border border-background-200/70 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-primary-100/70 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200/70 transition-colors">
                <i className={`${item.icon} text-primary-500 text-xl`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.count}</p>
              </div>
            </div>
          ))}

          {indexItems.slice(4).map((item, i) => (
            <div
              key={i + 4}
              className="group flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors border border-background-200/70 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-accent-100/70 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200/70 transition-colors">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.count}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}